<template>
	<page-container>
		<p style="font-size: 30px; line-height: 45px;" class="f-c-33 f-w-500">企业注册</p>
		<p style="font-size: 16px; line-height: 24px;" class="f-c-99 f-w-500">欢迎加入AI快销</p>
		<div class="input-item" style="margin-top: 17px;">
			<input class="form-input" type="text" autofocus="" placeholder="公司名称" @keyup.enter="register" @input="nameWarn = ''" v-model="form.name" />
			<div class="input-item-tip" v-if="nameWarn">{{ nameWarn }}</div>
		</div>
		<div class="input-item">
			<input class="form-input" type="text" autofocus="" placeholder="请输入手机号" @keyup.enter="register" @input="phoneWarn = ''" v-model="form.phone" />
			<div class="input-item-tip" v-if="phoneWarn">{{ phoneWarn }}</div>
		</div>
		<div class="input-item">
			<input class="form-input" type="password" autocomplete="new-password" autofocus="" placeholder="请设置密码（6-16位数字和字母）" @keyup.enter="register" @input="passwordWarn = ''" v-model="form.password" />
			<div class="input-item-tip" v-if="passwordWarn">{{ passwordWarn }}</div>
		</div>
		<div class="input-item">
			<input class="form-input" autofocus="" @keyup.enter="register" placeholder="请输入短信验证码" v-model="form.code" />
			<div class="button-min-inner button-min" @click="getCode" v-if="!getting">获取验证码</div>
			<div class="button-min-inner button-min" v-if="getting">重新获取 {{ time }}s</div>
			<div class="input-item-tip" v-if="codeWarn">{{ codeWarn }}</div>
		</div>
		<button style="margin-top: 17px;" class="form-btn" type="primary" @click="register" @keyup.enter="register">注册</button>
		<p class="f-s-16 f-c-33" style="padding: 22px 0;">已有账号？<span @click="login" class="button-min">立即登录</span></p>
	</page-container>
</template>

<script>
import pageContainer from '../components/page-container.vue';
import md5 from 'js-md5';
export default {
	name: 'register',
	data() {
		return {
			form: {
				name: '',
				password: '',
				phone: '',
				code: '',
			},
			nameWarn: '',
			passwordWarn: '',
			phoneWarn: '',
			codeWarn: '',
			bubuid: '',
			getting: false,
			time: 60,
			loading: false,
		};
	},
	components: {
		pageContainer,
	},
	methods: {
		register() {
			if (!this.loading && this.validation()) {
				this.loading = true;
				this.$api.register({
					params: {
						ORIGIN_API: true,
						'USER.NAME': this.form.name,
						'USER.LOGIN_ID': this.form.phone,
						'USER.LOGIN_PASSWORD': this.form.password,
						APP_TOKEN: '9C4F2C2F67E34BB29BF296DBDBF26922',
						APP_SOURCE: 2,
						SMS_CODE: this.form.code,
						EXPERIENCE_INFO: '',
						INVITE_CODE: this.getInviteCode(),
						CHANNEL: 20083,
					},
					headers: {
						token: this.bubuid,
					},
					success: res => {
						this.$router.push({
							name: 'Login',
							params: this.form
						});
						alert('恭喜！注册成功');
					},
					fail: res => {
						if (res.msg) {
							if (res.msg.indexOf('验证码') !== -1) {
								this.codeWarn = res.msg;
							} else if (res.msg.indexOf('密码') !== -1) {
								this.passwordWarn = res.msg;
							} else if (res.msg.indexOf('公司') !== -1) {
								this.nameWarn = res.msg;
							} else {
								this.phoneWarn = res.msg;
							}
						}
					},
					complete: () => {
						this.loading = false;
					},
				});
			}
		},
		login() {
			this.$router.push({
				path: '/',
			});
		},
		getInviteCode() {
			let date = new Date();
			let m = date.getMonth() + 1;
			let month = m >= 10 ? m : '0' + m;
			let d = date.getDate();
			let day = d >= 10 ? d : '0' + d;
			let h = date.getHours();
			let hour = h >= 10 ? h : '0' + h;
			return [month, day, hour].join('');
		},
		validation() {
			this.nameWarn = '';
			this.phoneWarn = '';
			this.codeWarn = '';
			this.passwordWarn = '';
			if (!this.form.name) {
				this.nameWarn = '公司名称不能为空';
				return false;
			}
			if (!this.form.phone) {
				this.phoneWarn = '手机号不能为空';
				return false;
			}
			if (!this.form.password) {
				this.passwordWarn = '密码不能为空';
				return false;
			}
			if (!this.form.code) {
				this.codeWarn = '验证码不能为空';
				return false;
			}
			return true;
		},
		getCode() {
			if (!this.getting) {
				if (this.form.phone.length != 11) {
					this.phoneWarn = '请填写正确的手机号码';
				} else {
					this.getting = true;
					let dis = function(that) {
						setTimeout(() => {
							that.time--;
							if (that.time == 0) {
								that.getting = false;
								that.time = 59;
							} else {
								dis(that);
							}
						}, 1000);
					};
					dis(this);
					this.$api.getCode({
						params: Object.assign({}, this.getMd5Key(this.form.phone), {
							ORIGIN_API: true,
							PHONE: this.form.phone,
							APP_SOURCE: 2,
						}),
						success: res => {
							this.bubuid = res.extraData.bubuId;
						},
					});
				}
			}
		},
		getMd5Key(phone) {
			let time = new Date();
			let y = time.getFullYear();
			let m = time.getMonth() + 1;
			let d = time.getDate();
			let day = [y, m >= 10 ? m : '0' + m, d >= 10 ? d : '0' + d];
			let rdmKey = (parseInt((Math.random() + 1) * Math.pow(10, 8)) + '').substr(1, 8) + day.join('');
			return {
				RDM_KEY: rdmKey,
				SER_KEY: md5(phone + rdmKey + 'akx_808088'),
			};
		},
	},
};
</script>

<style scoped lang="scss">
.input-item {
	padding-bottom: 17px;
	padding-top: 17px;
	position: relative;
}
.input-item-tip {
	position: absolute;
	left: 0;
	bottom: -8px;
	font-size: 14px;
	color: #f46c50;
	line-height: 21px;
}
.input-item-tip:before {
	content: '';
	display: inline-block;
	width: 14px;
	height: 14px;
	background-position: center;
	background-size: contain;
	vertical-align: middle;
	margin-right: 6px;
	background-image: url(../assets/cut.png);
}
.button-min-inner {
	position: absolute;
	top: 32px;
	line-height: 24px;
	font-size: 16px;
	right: 12px;
}
.button-min {
	color: #f46c50;
	cursor: pointer;
}
.button-min:hover {
	opacity: 0.8;
}
</style>
